// IMPORTANT! if some of these schema will be updated please sync them with json-type-checker/src/HeaderNew/HeaderLite/schema.ts

import { Infer, array, nullable, object, string } from "superstruct";
import { LiveInspectorData } from "types/types";
import { cfJsonAnchorSchema } from "components/Anchor/schema";
import { translationsSchema } from "components/HeaderNew/schema";

// top menu schema of header lite
export const cfHeaderMenuLiteSchema = object({
  logo: object({
    image: object({
      // the url of the page where we land when clicking on the image
      url: string(),
      // the src of the image
      src: string(),
      alt: string(),
    }),
    ctaAnchor: nullable(cfJsonAnchorSchema),
  }),
});

// not ui related schema for header lite
const headerLiteSettingsSchema = object({
  logo: object({
    image: object({
      // the src of the image
      src: string(),
      alt: string(),
    }),
    // link of the logo
    ctaAnchor: nullable(cfJsonAnchorSchema),
  }),
  translations: translationsSchema,
});

// single item schema of the top menu
const headerLiteMenuItemSchema = object({
  label: string(),
  ...cfJsonAnchorSchema.schema,
});

// header lite general schema
const headerLiteSchema = object({
  __typename: string(),
  contentful_id: string(),
  menu: array(headerLiteMenuItemSchema),
  menuIdentifiers: object({
    __typename: string(),
    contentful_id: string(),
  }),
  settings: headerLiteSettingsSchema,
});

export { headerLiteSchema };

export type HeaderLiteSchema = Infer<typeof headerLiteSchema>;

export type HeaderMenuLiteItemSchema = Infer<typeof headerLiteMenuItemSchema>;

export type HeaderLiteSettingsSchema = Infer<typeof headerLiteSettingsSchema>;

export type CfHeaderMenuLiteData = {
  dataJson: HeaderLiteSchema;
};

export type CfHeaderLiteProps = Infer<typeof cfHeaderMenuLiteSchema> & {
  __typename: string;
  contentful_id: string;
  menu: CfHeaderMenuLiteData;
  liveInspector: LiveInspectorData;
};
